import React from 'react';
import lazyImage from '../components/lazy-images';

class Image extends React.Component {
  constructor(props) {
    super(props);
    const width = parseInt(props.size.split('x')[0]);
    const height = parseInt(props.size.split('x')[1]) || width;
    const imageBase = props.src.substring(0, props.src.lastIndexOf('.'));
    const imageExtension = props.src.replace(imageBase, '');
    this.state = {
      svg: `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'></svg>`,
      src: `${imageBase}_${width}x${height}${imageExtension}`,
      srcset: `${imageBase}_${width}x${height}${imageExtension}, ${imageBase}_${Math.floor(width*1.5)}x${Math.floor(height*1.5)}${imageExtension} 1.5x, ${imageBase}_${Math.floor(width*2)}x${Math.floor(height*2)}${imageExtension} 2x`
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.src === prevProps.src) {
      this.props.onImageUpdate && this.props.onImageUpdate();
      return;
    }
    const width = parseInt(this.props.size.split('x')[0])
    const height = parseInt(this.props.size.split('x')[1]) || width
    const imageBase = this.props.src.substring(0, this.props.src.lastIndexOf('.'))
    const imageExtension = this.props.src.replace(imageBase, '')
    this.setState({
      width,
      height,
      imageBase,
      imageExtension,
      svg: `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'></svg>`,
      src: `${imageBase}_${width}x${height}${imageExtension}`,
      srcset: `${imageBase}_${width}x${height}${imageExtension}, ${imageBase}_${Math.floor(width*1.5)}x${Math.floor(height*1.5)}${imageExtension} 1.5x, ${imageBase}_${Math.floor(width*2)}x${Math.floor(height*2)}${imageExtension} 2x`
    })
  }
 
  /* shouldComponentUpdate(nextProps) {
    return this.props.src === nextProps.src
  } */

  render() {
    return <img src={'data:image/svg+xml;charset=utf8,' + encodeURI(this.state.svg)} data-src={this.state.src} data-srcset={this.state.srcset} className={this.props.className} />
  }
}

export default Image;